var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "person-list-container" }, [
    _c(
      "div",
      {
        staticClass: "pointer no-border no-background-color",
        on: { click: _vm.toggleList }
      },
      [
        _c(
          "ul",
          { staticClass: "m-0" },
          [
            _vm.nbElements > 1
              ? _c("li", [
                  _c("div", { staticClass: "avatar", class: _vm.avatarSize }, [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.nbElements) +
                          "\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dinlineb ml-1" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.placeholder != ""
                            ? _vm.placeholder
                            : _vm.$l10n.n__(
                                "Personne",
                                "Personnes",
                                _vm.nbElements
                              )
                        ) +
                        "\n                "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.list, function(elem) {
              return _vm.nbElements == 1
                ? _c(
                    "li",
                    { key: elem.id },
                    [
                      _c("avatar-inline", {
                        attrs: {
                          "enable-avatar": _vm.enableAvatar,
                          data: elem,
                          size: _vm.size,
                          context: _vm.context,
                          "related-data": _vm.relatedData
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.displayList
      ? _c(
          "div",
          {
            staticClass:
              "person-list pabsolute zi-1000 top-left well p-0 span_12 shadow b-0 ellipsis wp-10",
            on: { click: _vm.toggleList, mouseleave: _vm.toggleList }
          },
          [
            _c("ul", { staticClass: "m-0" }, [
              _c("li", { staticClass: "p-2" }, [
                _c("div", { staticClass: "avatar", class: _vm.avatarSize }, [
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.nbElements) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dinlineb ml-1" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.placeholder != ""
                          ? _vm.placeholder
                          : _vm.$l10n.n__(
                              "Personne",
                              "Personnes",
                              _vm.nbElements
                            )
                      ) +
                      "\n                "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "person m-0 bt-1 pt-1 mxh-200 ovy-auto" },
              _vm._l(_vm.list, function(elem) {
                return _c(
                  "li",
                  { key: elem.id, staticClass: "p-2 cpointer" },
                  [
                    _c("avatar-inline", {
                      attrs: {
                        data: elem,
                        size: _vm.size,
                        context: _vm.context,
                        "related-data": _vm.relatedData,
                        "enable-avatar": _vm.enableAvatar
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }